export default "__VITE_ASSET__rE52uN3$__"